// extracted by mini-css-extract-plugin
module.exports = {"posts":"blog-module--posts--VXHoT","post":"blog-module--post--12gh8"};